import { ApiEnvironment } from '../../models/api-environment';

export class LicenseTrackerEnvironment extends ApiEnvironment {
  get reportUrl() {
    return `${this.baseUrl}/licensetracker/v1/report`;
  }

  get expirationmetricsAccountsReportUrl() {
    return `${this.baseUrl}/licensetracker/v1/expirationmetrics/accounts/report`;
  }

  accountsProductIdChurnReport(productId: string) {
    return `${this.baseUrl}/licensetracker/v1/accounts/product/${productId}/churnreport`;
  }

  override resolve(environment: unknown) {
    return environment instanceof LicenseTrackerEnvironment
      ? environment
      : this;
  }
}

export const licenseTrackerEnvironment = new LicenseTrackerEnvironment();
